import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=c1b36cfa"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports